import React, { useState } from "react";
import QRGenerator from "./qrcode";
import BarcodeGenerator from "./barcode-generator";
import "./home-qr-barcode-generator.css";

function HomeQrBarcodeGenerator() {
  const [activePanel, setActivePanel] = useState("qr");

  return (
    <main className="glaxmore-home">
      {/* Hero Section */}
      <header className="hero-section">
        <div className="hero-overlay" aria-hidden="true"></div>

        <div className="hero-content">
          <span className="hero-badge">
            Est. 2021
          </span>

          <h1>
            GLAXMORE IT
            <span>Your Partner in Smarter IT Innovation</span>
          </h1>

          <p>
            Generate professional QR Codes and Barcodes instantly.
            Fast, secure, reliable and designed for modern businesses.
          </p>

          <div 
            className="generator-switcher" 
            role="tablist" 
            aria-label="Generator Type Selector"
          >
            <button
              className={`switch-btn ${activePanel === "qr" ? "active" : ""}`}
              onClick={() => setActivePanel("qr")}
              role="tab"
              aria-selected={activePanel === "qr"}
              aria-controls="generator-panel"
              id="tab-qr"
            >
              QR Generator
            </button>

            <button
              className={`switch-btn ${activePanel === "barcode" ? "active" : ""}`}
              onClick={() => setActivePanel("barcode")}
              role="tab"
              aria-selected={activePanel === "barcode"}
              aria-controls="generator-panel"
              id="tab-barcode"
            >
              Barcode Generator
            </button>
          </div>
        </div>
      </header>

      {/* Generator Panel */}
      <section 
        className="generator-section"
        role="tabpanel"
        id="generator-panel"
        aria-labelledby={activePanel === "qr" ? "tab-qr" : "tab-barcode"}
      >
        <div className={`generator-card ${activePanel === "qr" ? "slide-left" : "slide-right"}`}>
          {activePanel === "qr" ? (
            <QRGenerator />
          ) : (
            <BarcodeGenerator />
          )}
        </div>
      </section>
    </main>
  );
}

export default HomeQrBarcodeGenerator;